export default __webpack_public_path__ + "static/media/team-1.c821a273.jpg";